import { render, staticRenderFns } from "./DetailMerchantCompanyComponent.vue?vue&type=template&id=08096797&"
import script from "./DetailMerchantCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./DetailMerchantCompanyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports